module.exports = __webpack_public_path__ + "static/media/icon_elevator.4733d92c.svg";